import { SvgIcon } from '@mui/material';
import React from 'react';

const SCORetractionIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="Calque_1"
        data-name="Calque 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 176.82 150"
        strokeWidth={0}
        fill="currentColor"
      >
        <g>
          <rect x="53.27" y="53.2" width="70.28" height="60.23" />
          <polygon points="90.07 49.87 123.55 49.87 113.45 36.58 90.07 36.58 90.07 49.87" />
          <polygon points="86.75 49.87 53.27 49.87 63.37 36.58 86.75 36.58 86.75 49.87" />
        </g>
        <g>
          <path d="m145.01,74.04l-2.15,45.32,33.96-30.09-14.69-.66c.82-4.47,1.28-9.03,1.28-13.61C163.41,33.64,129.77,0,88.41,0c-17.22,0-34.04,5.99-47.37,16.86l6.02,7.38c11.63-9.49,26.32-14.72,41.35-14.72,36.1,0,65.48,29.37,65.48,65.48,0,2.84-.2,5.67-.56,8.47l-8.31-9.43Z" />
          <path d="m88.41,140.48c-36.1,0-65.48-29.37-65.48-65.48,0-2.84.2-5.67.56-8.47l8.31,9.43,2.15-45.32L0,60.72l14.69.66c-.82,4.47-1.28,9.03-1.28,13.61,0,41.36,33.64,75,75,75,17.22,0,34.04-5.99,47.37-16.86l-6.02-7.38c-11.63,9.49-26.32,14.72-41.35,14.72Z" />
        </g>
      </svg>
    </SvgIcon>
  );
};

export default SCORetractionIcon;
